/** The "Back to Top" button label in English, French and Spanish, read by `BackToTop.tsx`. */
import { LanguageContent } from "@ryerson/frontend.common";
import { BackToTopProps } from "./BackToTop";

/** The label per language, picked with `useApplication().localization.language`. */
export const BackToTopContent: LanguageContent<BackToTopProps> = {
	en: {
		buttonLabel: "Back to Top",
	},
	fr: {
		buttonLabel: "Retour au haut de la page",
	},
	es: {
		buttonLabel: "Volver a la parte superior",
	},
};
